var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-specific-layout',{attrs:{"title":_vm.$t('about.title'),"description":_vm.$t('about.description'),"btnText":_vm.$t('about.btn'),"btnTo":_vm.ROUTE.SKILLS.PATH},scopedSlots:_vm._u([{key:"content-right",fn:function(){return [_c('timeline')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }